import type { SVGProps } from 'react';

const SvgDanger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M12.957 2.417a4.599 4.599 0 0 0-4.922 2.276L1.849 15.828a4.324 4.324 0 0 0 3.78 6.424H18.48a4.324 4.324 0 0 0 3.78-6.424L16.075 4.693a4.598 4.598 0 0 0-3.118-2.276Z'
      fill='currentColor'
      fillRule='evenodd'
      opacity={0.3}
    />
    <path
      d='M12.055 9v4M12.055 16v.5'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgDanger;
